import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { RoadmapExplorerGoalsAccordion } from 'Components/UI/roadmapExplorer/goalsAccordion';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDEmphasisSurface, FDPaper, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { GuidedHouseholdReviewZoneDescriptions } from 'Components/UI/guidedHouseholdReview/zoneDescriptions';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { dataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('GuidedHouseholdReviewIntroToGoalThresholdsLayout', () => ({
  noBackground: {
    '& > *': {
      backgroundColor: 'transparent !important', // !important needed to override FD
    },
  },
}));

export const GuidedHouseholdReviewIntroToGoalThresholdsLayout = () => {
  const { resource, saving, onSubmit } = useMetaLayoutContext();
  const classes = useStyles();
  return (
    <FDStack direction={'column'} justifyContent="center" alignItems="center" flex={1} spacing={3} paddingY={4}>
      <FDEmphasisSurface padding={8}>
        <FDStack direction="column" alignItems="center" justifyContent="center" spacing={3} paddingX={8}>
          <MetaControlField attr="title" />
          <MetaControlField attr="description" />
          <RoadmapExplorerGoalsAccordion condensed goals={resource.attr('goals').resources().list()} />
          <GuidedHouseholdReviewZoneDescriptions resource={resource} />
          <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <div className={classes.noBackground}>
              <FDPaper appearance="flat" rounded>
                <WizardBackButtonRel size="lg" resource={resource} />
              </FDPaper>
            </div>
            <div className={classes.noBackground}>
              <FDPaper appearance="flat" rounded>
                <FDPrimaryActionButton
                  {...dataAttrs('submit-btn')}
                  loading={saving}
                  onClick={onSubmit}
                  label={resource.attr('primaryActionLabel') || 'Submit'}
                  size="lg"
                  icon="arrowRight"
                  iconPosition="end"
                />
              </FDPaper>
            </div>
          </FDStack>
        </FDStack>
      </FDEmphasisSurface>
    </FDStack>
  );
};
